
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.733 0H3.429c-.631 0-1.143.512-1.143 1.143v13.714c0 .631.512 1.143 1.143 1.143h9.143c.631 0 1.143-.512 1.143-1.143V3.964h-2.84a1.143 1.143 0 01-1.142-1.143V0zm-1.39 8.393h1.64v.715h-1.64v-.715zm0 1.286h1.64v.84h-1.64v-.84zm-.686.84v-.84H6.018v.84h1.64zm-1.639.571h1.64v.696h-1.64v-.696zm2.325 0h1.64v.696h-1.64v-.696zm-.686-2.697v.715H6.018v-.715h1.64zm-2.496 4.25V7.536h5.679v5.107H5.16z","fill":"#748190"}}),_c('path',{attrs:{"d":"M9.536.197l3.978 3.978","stroke":"#748190","stroke-width":".571"}})])
          )
        }
      }
    